const flightData = {
  data: [
    {
      countryCode: "JP",
      stationSchedules: [
        {
          iataCode: "OKJ",
          schedules: [
            {
              origin: "TPE",
              destination: "OKJ",
              carrierCode: "IT",
              flightNumber: "214",
              departureTime: "11:10:00",
              arrivalTime: "14:35:00",
              daysOfWeek: {
                monday: true,
                tuesday: true,
                wednesday: true,
                thursday: true,
                friday: true,
                saturday: true,
                sunday: true,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 220,
            },
            {
              origin: "OKJ",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "215",
              departureTime: "15:25:00",
              arrivalTime: "17:30:00",
              daysOfWeek: {
                monday: true,
                tuesday: true,
                wednesday: true,
                thursday: true,
                friday: true,
                saturday: true,
                sunday: true,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 290,
            },
            {
              origin: "TPE",
              destination: "OKJ",
              carrierCode: "IT",
              flightNumber: "714",
              departureTime: "13:05:00",
              arrivalTime: "16:30:00",
              daysOfWeek: {
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: true,
                friday: false,
                saturday: false,
                sunday: true,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 220,
            },
            {
              origin: "OKJ",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "715",
              departureTime: "17:55:00",
              arrivalTime: "19:55:00",
              daysOfWeek: {
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: false,
                sunday: true,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 290,
            },
            {
              origin: "OKJ",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "715",
              departureTime: "17:55:00",
              arrivalTime: "20:00:00",
              daysOfWeek: {
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: true,
                friday: false,
                saturday: false,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 290,
            },
            {
              origin: "KHH",
              destination: "OKJ",
              carrierCode: "IT",
              flightNumber: "262",
              departureTime: "12:40:00",
              arrivalTime: "16:30:00",
              daysOfWeek: {
                monday: true,
                tuesday: false,
                wednesday: true,
                thursday: false,
                friday: true,
                saturday: false,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 220,
            },
            {
              origin: "OKJ",
              destination: "KHH",
              carrierCode: "IT",
              flightNumber: "263",
              departureTime: "17:55:00",
              arrivalTime: "20:20:00",
              daysOfWeek: {
                monday: true,
                tuesday: false,
                wednesday: true,
                thursday: false,
                friday: true,
                saturday: false,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 290,
            },
          ],
        },
        {
          iataCode: "YGJ",
          schedules: [
            {
              origin: "TPE",
              destination: "YGJ",
              carrierCode: "IT",
              flightNumber: "724",
              departureTime: "08:40:00",
              arrivalTime: "12:00:00",
              daysOfWeek: {
                monday: true,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: false,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 220,
            },
            {
              origin: "TPE",
              destination: "YGJ",
              carrierCode: "IT",
              flightNumber: "724",
              departureTime: "13:25:00",
              arrivalTime: "16:50:00",
              daysOfWeek: {
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: true,
                saturday: false,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 220,
            },
            {
              origin: "YGJ",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "725",
              departureTime: "13:00:00",
              arrivalTime: "15:20:00",
              daysOfWeek: {
                monday: true,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: false,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 290,
            },
            {
              origin: "YGJ",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "725",
              departureTime: "17:50:00",
              arrivalTime: "20:00:00",
              daysOfWeek: {
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: true,
                saturday: false,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 290,
            },
          ],
        },
        {
          iataCode: "HKD",
          schedules: [
            {
              origin: "TPE",
              destination: "HKD",
              carrierCode: "IT",
              flightNumber: "236",
              departureTime: "06:45:00",
              arrivalTime: "11:10:00",
              daysOfWeek: {
                monday: true,
                tuesday: false,
                wednesday: true,
                thursday: true,
                friday: true,
                saturday: false,
                sunday: true,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 220,
            },
            {
              origin: "HKD",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "237",
              departureTime: "21:20:00",
              arrivalTime: "15:45:00",
              daysOfWeek: {
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: true,
                friday: false,
                saturday: false,
                sunday: true,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 290,
            },
            {
              origin: "HKD",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "237",
              departureTime: "12:20:00",
              arrivalTime: "16:00:00",
              daysOfWeek: {
                monday: true,
                tuesday: false,
                wednesday: true,
                thursday: false,
                friday: true,
                saturday: false,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 290,
            },
          ],
        },
        {
          iataCode: "AKJ",
          schedules: [
            {
              origin: "TPE",
              destination: "AKJ",
              carrierCode: "IT",
              flightNumber: "238",
              departureTime: "07:35:00",
              arrivalTime: "12:30:00",
              daysOfWeek: {
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: true,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 230,
            },
            {
              origin: "TPE",
              destination: "AKJ",
              carrierCode: "IT",
              flightNumber: "238",
              departureTime: "07:50:00",
              arrivalTime: "12:30:00",
              daysOfWeek: {
                monday: false,
                tuesday: true,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: false,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 230,
            },
            {
              origin: "AKJ",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "239",
              departureTime: "14:00:00",
              arrivalTime: "18:05:00",
              daysOfWeek: {
                monday: false,
                tuesday: true,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: true,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 270,
            },
          ],
        },
        {
          iataCode: "NRT",
          schedules: [
            {
              origin: "TPE",
              destination: "NRT",
              carrierCode: "IT",
              flightNumber: "200",
              departureTime: "06:10:00",
              arrivalTime: "10:35:00",
              daysOfWeek: {
                monday: false,
                tuesday: false,
                wednesday: true,
                thursday: false,
                friday: false,
                saturday: true,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 205,
            },
            {
              origin: "TPE",
              destination: "NRT",
              carrierCode: "IT",
              flightNumber: "200",
              departureTime: "06:35:00",
              arrivalTime: "10:35:00",
              daysOfWeek: {
                monday: true,
                tuesday: true,
                wednesday: false,
                thursday: true,
                friday: false,
                saturday: false,
                sunday: true,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 180,
            },
            {
              origin: "TPE",
              destination: "NRT",
              carrierCode: "IT",
              flightNumber: "202",
              departureTime: "13:30:00",
              arrivalTime: "17:30:00",
              daysOfWeek: {
                monday: true,
                tuesday: false,
                wednesday: true,
                thursday: false,
                friday: true,
                saturday: true,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 180,
            },
            {
              origin: "TPE",
              destination: "NRT",
              carrierCode: "IT",
              flightNumber: "202",
              departureTime: "15:35:00",
              arrivalTime: "19:35:00",
              daysOfWeek: {
                monday: false,
                tuesday: true,
                wednesday: false,
                thursday: true,
                friday: false,
                saturday: false,
                sunday: true,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 180,
            },
            {
              origin: "NRT",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "201",
              departureTime: "11:25:00",
              arrivalTime: "14:45:00",
              daysOfWeek: {
                monday: false,
                tuesday: true,
                wednesday: false,
                thursday: true,
                friday: false,
                saturday: false,
                sunday: true,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 260,
            },
            {
              origin: "NRT",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "201",
              departureTime: "12:00:00",
              arrivalTime: "15:25:00",
              daysOfWeek: {
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: true,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 265,
            },
            {
              origin: "NRT",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "201",
              departureTime: "13:00:00",
              arrivalTime: "16:25:00",
              daysOfWeek: {
                monday: true,
                tuesday: false,
                wednesday: true,
                thursday: false,
                friday: false,
                saturday: false,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 265,
            },
            {
              origin: "NRT",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "203",
              departureTime: "18:25:00",
              arrivalTime: "21:50:00",
              daysOfWeek: {
                monday: true,
                tuesday: false,
                wednesday: true,
                thursday: false,
                friday: false,
                saturday: false,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 265,
            },
            {
              origin: "NRT",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "203",
              departureTime: "18:25:00",
              arrivalTime: "21:55:00",
              daysOfWeek: {
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: true,
                saturday: false,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 270,
            },
            {
              origin: "NRT",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "203",
              departureTime: "18:30:00",
              arrivalTime: "21:50:00",
              daysOfWeek: {
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: true,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 260,
            },
            {
              origin: "NRT",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "203",
              departureTime: "20:25:00",
              arrivalTime: "23:30:00",
              daysOfWeek: {
                monday: false,
                tuesday: true,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: false,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 245,
            },
            {
              origin: "NRT",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "203",
              departureTime: "20:25:00",
              arrivalTime: "23:25:00",
              daysOfWeek: {
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: true,
                friday: false,
                saturday: false,
                sunday: true,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 240,
            },
            {
              origin: "KHH",
              destination: "NRT",
              carrierCode: "IT",
              flightNumber: "280",
              departureTime: "06:55:00",
              arrivalTime: "11:10:00",
              daysOfWeek: {
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: true,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 195,
            },
            {
              origin: "KHH",
              destination: "NRT",
              carrierCode: "IT",
              flightNumber: "280",
              departureTime: "08:00:00",
              arrivalTime: "12:10:00",
              daysOfWeek: {
                monday: true,
                tuesday: true,
                wednesday: true,
                thursday: true,
                friday: false,
                saturday: false,
                sunday: true,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 190,
            },
            {
              origin: "NRT",
              destination: "KHH",
              carrierCode: "IT",
              flightNumber: "281",
              departureTime: "11:25:00",
              arrivalTime: "15:05:00",
              daysOfWeek: {
                monday: true,
                tuesday: false,
                wednesday: true,
                thursday: false,
                friday: false,
                saturday: true,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 280,
            },
            {
              origin: "NRT",
              destination: "KHH",
              carrierCode: "IT",
              flightNumber: "281",
              departureTime: "13:00:00",
              arrivalTime: "16:40:00",
              daysOfWeek: {
                monday: false,
                tuesday: true,
                wednesday: false,
                thursday: true,
                friday: false,
                saturday: false,
                sunday: true,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 280,
            },
          ],
        },
        {
          iataCode: "HND",
          schedules: [
            {
              origin: "TPE",
              destination: "HND",
              carrierCode: "IT",
              flightNumber: "216",
              departureTime: "00:10:00",
              arrivalTime: "04:00:00",
              daysOfWeek: {
                monday: true,
                tuesday: true,
                wednesday: true,
                thursday: true,
                friday: true,
                saturday: true,
                sunday: true,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 170,
            },
            {
              origin: "HND",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "217",
              departureTime: "05:00:00",
              arrivalTime: "07:55:00",
              daysOfWeek: {
                monday: true,
                tuesday: true,
                wednesday: true,
                thursday: true,
                friday: true,
                saturday: true,
                sunday: true,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 235,
            },
          ],
        },
        {
          iataCode: "FUK",
          schedules: [
            {
              origin: "TPE",
              destination: "FUK",
              carrierCode: "IT",
              flightNumber: "240",
              departureTime: "06:45:00",
              arrivalTime: "10:00:00",
              daysOfWeek: {
                monday: true,
                tuesday: true,
                wednesday: true,
                thursday: true,
                friday: true,
                saturday: true,
                sunday: true,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 135,
            },
            {
              origin: "TPE",
              destination: "FUK",
              carrierCode: "IT",
              flightNumber: "720",
              departureTime: "13:40:00",
              arrivalTime: "16:55:00",
              daysOfWeek: {
                monday: true,
                tuesday: true,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: false,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 135,
            },
            {
              origin: "FUK",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "241",
              departureTime: "10:55:00",
              arrivalTime: "12:40:00",
              daysOfWeek: {
                monday: true,
                tuesday: true,
                wednesday: true,
                thursday: true,
                friday: true,
                saturday: true,
                sunday: true,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 165,
            },
            {
              origin: "FUK",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "721",
              departureTime: "17:55:00",
              arrivalTime: "19:35:00",
              daysOfWeek: {
                monday: false,
                tuesday: true,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: false,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 160,
            },
            {
              origin: "FUK",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "721",
              departureTime: "17:55:00",
              arrivalTime: "19:40:00",
              daysOfWeek: {
                monday: true,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: false,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 165,
            },
            {
              origin: "KHH",
              destination: "FUK",
              carrierCode: "IT",
              flightNumber: "270",
              departureTime: "15:25:00",
              arrivalTime: "18:55:00",
              daysOfWeek: {
                monday: false,
                tuesday: true,
                wednesday: false,
                thursday: false,
                friday: true,
                saturday: false,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 150,
            },
            {
              origin: "FUK",
              destination: "KHH",
              carrierCode: "IT",
              flightNumber: "271",
              departureTime: "19:55:00",
              arrivalTime: "21:55:00",
              daysOfWeek: {
                monday: false,
                tuesday: true,
                wednesday: false,
                thursday: false,
                friday: true,
                saturday: false,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 180,
            },
          ],
        },
        {
          iataCode: "CTS",
          schedules: [
            {
              origin: "TPE",
              destination: "CTS",
              carrierCode: "IT",
              flightNumber: "234",
              departureTime: "06:15:00",
              arrivalTime: "10:55:00",
              daysOfWeek: {
                monday: false,
                tuesday: true,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: false,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 220,
            },
            {
              origin: "TPE",
              destination: "CTS",
              carrierCode: "IT",
              flightNumber: "234",
              departureTime: "06:20:00",
              arrivalTime: "10:55:00",
              daysOfWeek: {
                monday: true,
                tuesday: false,
                wednesday: true,
                thursday: true,
                friday: true,
                saturday: true,
                sunday: true,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 215,
            },
            {
              origin: "CTS",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "235",
              departureTime: "11:55:00",
              arrivalTime: "15:35:00",
              daysOfWeek: {
                monday: true,
                tuesday: true,
                wednesday: true,
                thursday: true,
                friday: true,
                saturday: true,
                sunday: true,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 280,
            },
          ],
        },
        {
          iataCode: "KMI",
          schedules: [
            {
              origin: "TPE",
              destination: "KMI",
              carrierCode: "IT",
              flightNumber: "742",
              departureTime: "06:05:00",
              arrivalTime: "09:20:00",
              daysOfWeek: {
                monday: true,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: false,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 135,
            },
            {
              origin: "TPE",
              destination: "KMI",
              carrierCode: "IT",
              flightNumber: "742",
              departureTime: "06:10:00",
              arrivalTime: "09:20:00",
              daysOfWeek: {
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: true,
                saturday: false,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 130,
            },
            {
              origin: "KMI",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "743",
              departureTime: "10:30:00",
              arrivalTime: "12:00:00",
              daysOfWeek: {
                monday: true,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: true,
                saturday: false,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 150,
            },
          ],
        },
        {
          iataCode: "KIX",
          schedules: [
            {
              origin: "TPE",
              destination: "KIX",
              carrierCode: "IT",
              flightNumber: "210",
              departureTime: "06:55:00",
              arrivalTime: "10:25:00",
              daysOfWeek: {
                monday: false,
                tuesday: true,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: false,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 150,
            },
            {
              origin: "TPE",
              destination: "KIX",
              carrierCode: "IT",
              flightNumber: "210",
              departureTime: "07:00:00",
              arrivalTime: "10:25:00",
              daysOfWeek: {
                monday: true,
                tuesday: false,
                wednesday: true,
                thursday: false,
                friday: true,
                saturday: true,
                sunday: true,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 145,
            },
            {
              origin: "TPE",
              destination: "KIX",
              carrierCode: "IT",
              flightNumber: "212",
              departureTime: "14:40:00",
              arrivalTime: "17:55:00",
              daysOfWeek: {
                monday: true,
                tuesday: true,
                wednesday: false,
                thursday: false,
                friday: true,
                saturday: false,
                sunday: true,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 135,
            },
            {
              origin: "KIX",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "211",
              departureTime: "11:30:00",
              arrivalTime: "13:50:00",
              daysOfWeek: {
                monday: true,
                tuesday: true,
                wednesday: true,
                thursday: false,
                friday: true,
                saturday: true,
                sunday: true,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 200,
            },
            {
              origin: "KIX",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "213",
              departureTime: "18:55:00",
              arrivalTime: "21:20:00",
              daysOfWeek: {
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: true,
                saturday: false,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 205,
            },
            {
              origin: "KIX",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "213",
              departureTime: "18:55:00",
              arrivalTime: "21:15:00",
              daysOfWeek: {
                monday: true,
                tuesday: true,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: false,
                sunday: true,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 200,
            },
            {
              origin: "KHH",
              destination: "KIX",
              carrierCode: "IT",
              flightNumber: "284",
              departureTime: "06:55:00",
              arrivalTime: "10:40:00",
              daysOfWeek: {
                monday: true,
                tuesday: true,
                wednesday: true,
                thursday: true,
                friday: true,
                saturday: true,
                sunday: true,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 165,
            },
            {
              origin: "KIX",
              destination: "KHH",
              carrierCode: "IT",
              flightNumber: "285",
              departureTime: "11:30:00",
              arrivalTime: "14:00:00",
              daysOfWeek: {
                monday: true,
                tuesday: true,
                wednesday: true,
                thursday: true,
                friday: true,
                saturday: true,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 210,
            },
            {
              origin: "KIX",
              destination: "KHH",
              carrierCode: "IT",
              flightNumber: "285",
              departureTime: "11:30:00",
              arrivalTime: "14:00:00",
              daysOfWeek: {
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: false,
                sunday: true,
              },
              operationDateSummary: "2025/11/02-2026/03/28",
              overnight: 0,
              durationInMinutes: 210,
            },
            {
              origin: "KIX",
              destination: "KHH",
              carrierCode: "IT",
              flightNumber: "285",
              departureTime: "12:00:00",
              arrivalTime: "14:30:00",
              daysOfWeek: {
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: false,
                sunday: true,
              },
              operationDateSummary: "2025/10/26",
              overnight: 0,
              durationInMinutes: 210,
            },
          ],
        },
        {
          iataCode: "OKA",
          schedules: [
            {
              origin: "TPE",
              destination: "OKA",
              carrierCode: "IT",
              flightNumber: "230",
              departureTime: "06:35:00",
              arrivalTime: "08:55:00",
              daysOfWeek: {
                monday: true,
                tuesday: true,
                wednesday: true,
                thursday: true,
                friday: true,
                saturday: true,
                sunday: true,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 80,
            },
            {
              origin: "TPE",
              destination: "OKA",
              carrierCode: "IT",
              flightNumber: "232",
              departureTime: "18:20:00",
              arrivalTime: "20:40:00",
              daysOfWeek: {
                monday: true,
                tuesday: true,
                wednesday: true,
                thursday: true,
                friday: true,
                saturday: true,
                sunday: true,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 80,
            },
            {
              origin: "OKA",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "231",
              departureTime: "09:45:00",
              arrivalTime: "10:20:00",
              daysOfWeek: {
                monday: true,
                tuesday: true,
                wednesday: true,
                thursday: true,
                friday: true,
                saturday: true,
                sunday: true,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 95,
            },
            {
              origin: "OKA",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "233",
              departureTime: "21:30:00",
              arrivalTime: "21:55:00",
              daysOfWeek: {
                monday: false,
                tuesday: false,
                wednesday: true,
                thursday: false,
                friday: false,
                saturday: false,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 85,
            },
            {
              origin: "OKA",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "233",
              departureTime: "21:30:00",
              arrivalTime: "22:05:00",
              daysOfWeek: {
                monday: true,
                tuesday: true,
                wednesday: false,
                thursday: true,
                friday: true,
                saturday: true,
                sunday: true,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 95,
            },
          ],
        },
        {
          iataCode: "HNA",
          schedules: [
            {
              origin: "TPE",
              destination: "HNA",
              carrierCode: "IT",
              flightNumber: "258",
              departureTime: "14:00:00",
              arrivalTime: "17:50:00",
              daysOfWeek: {
                monday: false,
                tuesday: false,
                wednesday: true,
                thursday: false,
                friday: false,
                saturday: false,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 230,
            },
            {
              origin: "TPE",
              destination: "HNA",
              carrierCode: "IT",
              flightNumber: "258",
              departureTime: "14:05:00",
              arrivalTime: "17:50:00",
              daysOfWeek: {
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: true,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 225,
            },
            {
              origin: "HNA",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "259",
              departureTime: "17:50:00",
              arrivalTime: "21:10:00",
              daysOfWeek: {
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: true,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 260,
            },
            {
              origin: "HNA",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "259",
              departureTime: "17:50:00",
              arrivalTime: "20:55:00",
              daysOfWeek: {
                monday: false,
                tuesday: false,
                wednesday: true,
                thursday: false,
                friday: false,
                saturday: false,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 245,
            },
          ],
        },
        {
          iataCode: "KIJ",
          schedules: [
            {
              origin: "TPE",
              destination: "KIJ",
              carrierCode: "IT",
              flightNumber: "228",
              departureTime: "13:55:00",
              arrivalTime: "18:00:00",
              daysOfWeek: {
                monday: true,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: true,
                saturday: false,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 185,
            },
            {
              origin: "KIJ",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "229",
              departureTime: "19:00:00",
              arrivalTime: "22:30:00",
              daysOfWeek: {
                monday: true,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: true,
                saturday: false,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 270,
            },
          ],
        },
        {
          iataCode: "SDJ",
          schedules: [
            {
              origin: "TPE",
              destination: "SDJ",
              carrierCode: "IT",
              flightNumber: "254",
              departureTime: "14:35:00",
              arrivalTime: "18:45:00",
              daysOfWeek: {
                monday: false,
                tuesday: true,
                wednesday: false,
                thursday: true,
                friday: false,
                saturday: false,
                sunday: true,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 190,
            },
            {
              origin: "SDJ",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "255",
              departureTime: "19:40:00",
              arrivalTime: "23:00:00",
              daysOfWeek: {
                monday: false,
                tuesday: true,
                wednesday: false,
                thursday: true,
                friday: false,
                saturday: false,
                sunday: true,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 260,
            },
            {
              origin: "KHH",
              destination: "SDJ",
              carrierCode: "IT",
              flightNumber: "772",
              departureTime: "13:25:00",
              arrivalTime: "17:55:00",
              daysOfWeek: {
                monday: true,
                tuesday: false,
                wednesday: true,
                thursday: false,
                friday: false,
                saturday: true,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 210,
            },
            {
              origin: "SDJ",
              destination: "KHH",
              carrierCode: "IT",
              flightNumber: "773",
              departureTime: "18:50:00",
              arrivalTime: "22:30:00",
              daysOfWeek: {
                monday: true,
                tuesday: false,
                wednesday: true,
                thursday: false,
                friday: false,
                saturday: true,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 280,
            },
          ],
        },
        {
          iataCode: "YGJ",
          schedules: [
            {
              origin: "TPE",
              destination: "YGJ",
              carrierCode: "IT",
              flightNumber: "724",
              departureTime: "08:40:00",
              arrivalTime: "12:00:00",
              daysOfWeek: {
                monday: true,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: false,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 140,
            },
            {
              origin: "TPE",
              destination: "YGJ",
              carrierCode: "IT",
              flightNumber: "724",
              departureTime: "13:25:00",
              arrivalTime: "16:50:00",
              daysOfWeek: {
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: true,
                saturday: false,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 145,
            },
            {
              origin: "YGJ",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "725",
              departureTime: "13:00:00",
              arrivalTime: "15:20:00",
              daysOfWeek: {
                monday: true,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: false,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 200,
            },
            {
              origin: "YGJ",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "725",
              departureTime: "17:50:00",
              arrivalTime: "20:00:00",
              daysOfWeek: {
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: true,
                saturday: false,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 190,
            },
          ],
        },
      ],
    },
    {
      countryCode: "KR",
      stationSchedules: [
        {
          iataCode: "CJU",
          schedules: [
            {
              origin: "TPE",
              destination: "CJU",
              carrierCode: "IT",
              flightNumber: "654",
              departureTime: "06:30:00",
              arrivalTime: "09:20:00",
              daysOfWeek: {
                monday: false,
                tuesday: false,
                wednesday: true,
                thursday: false,
                friday: false,
                saturday: true,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 110,
            },
            {
              origin: "TPE",
              destination: "CJU",
              carrierCode: "IT",
              flightNumber: "654",
              departureTime: "06:40:00",
              arrivalTime: "09:50:00",
              daysOfWeek: {
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: false,
                sunday: true,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 130,
            },
            {
              origin: "TPE",
              destination: "CJU",
              carrierCode: "IT",
              flightNumber: "654",
              departureTime: "07:05:00",
              arrivalTime: "10:00:00",
              daysOfWeek: {
                monday: false,
                tuesday: true,
                wednesday: false,
                thursday: false,
                friday: true,
                saturday: false,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 115,
            },
            {
              origin: "TPE",
              destination: "CJU",
              carrierCode: "IT",
              flightNumber: "654",
              departureTime: "07:55:00",
              arrivalTime: "10:50:00",
              daysOfWeek: {
                monday: true,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: false,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 115,
            },
            {
              origin: "CJU",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "655",
              departureTime: "10:10:00",
              arrivalTime: "11:25:00",
              daysOfWeek: {
                monday: false,
                tuesday: false,
                wednesday: true,
                thursday: false,
                friday: false,
                saturday: true,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 135,
            },
            {
              origin: "CJU",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "655",
              departureTime: "10:50:00",
              arrivalTime: "12:10:00",
              daysOfWeek: {
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: false,
                sunday: true,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 140,
            },
            {
              origin: "CJU",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "655",
              departureTime: "11:00:00",
              arrivalTime: "12:15:00",
              daysOfWeek: {
                monday: false,
                tuesday: true,
                wednesday: false,
                thursday: false,
                friday: true,
                saturday: false,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 135,
            },
            {
              origin: "CJU",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "655",
              departureTime: "11:40:00",
              arrivalTime: "12:55:00",
              daysOfWeek: {
                monday: true,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: false,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 135,
            },
            {
              origin: "RMQ",
              destination: "CJU",
              carrierCode: "IT",
              flightNumber: "632",
              departureTime: "07:00:00",
              arrivalTime: "10:15:00",
              daysOfWeek: {
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: true,
                friday: false,
                saturday: false,
                sunday: true,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 135,
            },
            {
              origin: "CJU",
              destination: "RMQ",
              carrierCode: "IT",
              flightNumber: "633",
              departureTime: "19:50:00",
              arrivalTime: "21:05:00",
              daysOfWeek: {
                monday: false,
                tuesday: false,
                wednesday: true,
                thursday: false,
                friday: false,
                saturday: true,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 135,
            },
            {
              origin: "KHH",
              destination: "CJU",
              carrierCode: "IT",
              flightNumber: "670",
              departureTime: "15:35:00",
              arrivalTime: "19:00:00",
              daysOfWeek: {
                monday: true,
                tuesday: false,
                wednesday: true,
                thursday: false,
                friday: false,
                saturday: true,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 145,
            },
            {
              origin: "KHH",
              destination: "CJU",
              carrierCode: "IT",
              flightNumber: "670",
              departureTime: "16:00:00",
              arrivalTime: "19:25:00",
              daysOfWeek: {
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: true,
                saturday: false,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 145,
            },
            {
              origin: "CJU",
              destination: "KHH",
              carrierCode: "IT",
              flightNumber: "671",
              departureTime: "11:10:00",
              arrivalTime: "12:35:00",
              daysOfWeek: {
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: true,
                friday: false,
                saturday: false,
                sunday: true,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 145,
            },
            {
              origin: "CJU",
              destination: "KHH",
              carrierCode: "IT",
              flightNumber: "671",
              departureTime: "19:50:00",
              arrivalTime: "21:25:00",
              daysOfWeek: {
                monday: true,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: false,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 155,
            },
            {
              origin: "CJU",
              destination: "KHH",
              carrierCode: "IT",
              flightNumber: "671",
              departureTime: "20:15:00",
              arrivalTime: "21:50:00",
              daysOfWeek: {
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: true,
                saturday: false,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 155,
            },
          ],
        },
        {
          iataCode: "GMP",
          schedules: [
            {
              origin: "KHH",
              destination: "GMP",
              carrierCode: "IT",
              flightNumber: "662",
              departureTime: "15:55:00",
              arrivalTime: "19:45:00",
              daysOfWeek: {
                monday: true,
                tuesday: true,
                wednesday: false,
                thursday: true,
                friday: true,
                saturday: false,
                sunday: true,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 170,
            },
            {
              origin: "GMP",
              destination: "KHH",
              carrierCode: "IT",
              flightNumber: "663",
              departureTime: "20:35:00",
              arrivalTime: "22:40:00",
              daysOfWeek: {
                monday: true,
                tuesday: true,
                wednesday: false,
                thursday: true,
                friday: false,
                saturday: false,
                sunday: true,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 185,
            },
            {
              origin: "GMP",
              destination: "KHH",
              carrierCode: "IT",
              flightNumber: "663",
              departureTime: "20:35:00",
              arrivalTime: "22:40:00",
              daysOfWeek: {
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: true,
                saturday: false,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 185,
            },
          ],
        },
        {
          iataCode: "PUS",
          schedules: [
            {
              origin: "TPE",
              destination: "PUS",
              carrierCode: "IT",
              flightNumber: "606",
              departureTime: "16:50:00",
              arrivalTime: "20:00:00",
              daysOfWeek: {
                monday: true,
                tuesday: true,
                wednesday: true,
                thursday: false,
                friday: true,
                saturday: false,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 130,
            },
            {
              origin: "TPE",
              destination: "PUS",
              carrierCode: "IT",
              flightNumber: "606",
              departureTime: "16:50:00",
              arrivalTime: "20:05:00",
              daysOfWeek: {
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: true,
                friday: false,
                saturday: true,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 135,
            },
            {
              origin: "TPE",
              destination: "PUS",
              carrierCode: "IT",
              flightNumber: "606",
              departureTime: "17:00:00",
              arrivalTime: "20:00:00",
              daysOfWeek: {
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: false,
                sunday: true,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 120,
            },
            {
              origin: "PUS",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "607",
              departureTime: "20:50:00",
              arrivalTime: "22:30:00",
              daysOfWeek: {
                monday: true,
                tuesday: true,
                wednesday: true,
                thursday: false,
                friday: true,
                saturday: false,
                sunday: true,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 160,
            },
            {
              origin: "PUS",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "607",
              departureTime: "21:00:00",
              arrivalTime: "22:30:00",
              daysOfWeek: {
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: true,
                friday: false,
                saturday: true,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 150,
            },
          ],
        },
        {
          iataCode: "ICN",
          schedules: [
            {
              origin: "TPE",
              destination: "ICN",
              carrierCode: "IT",
              flightNumber: "602",
              departureTime: "20:00:00",
              arrivalTime: "23:30:00",
              daysOfWeek: {
                monday: true,
                tuesday: true,
                wednesday: true,
                thursday: true,
                friday: true,
                saturday: true,
                sunday: true,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 150,
            },
            {
              origin: "ICN",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "603",
              departureTime: "00:30:00",
              arrivalTime: "02:15:00",
              daysOfWeek: {
                monday: true,
                tuesday: true,
                wednesday: true,
                thursday: true,
                friday: true,
                saturday: true,
                sunday: true,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 165,
            },
          ],
        },
      ],
    },
    {
      countryCode: "MO",
      stationSchedules: [
        {
          iataCode: "MFM",
          schedules: [
            {
              origin: "KHH",
              destination: "MFM",
              carrierCode: "IT",
              flightNumber: "321",
              departureTime: "17:40:00",
              arrivalTime: "19:05:00",
              daysOfWeek: {
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: true,
                friday: false,
                saturday: false,
                sunday: true,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 85,
            },
            {
              origin: "MFM",
              destination: "KHH",
              carrierCode: "IT",
              flightNumber: "322",
              departureTime: "09:45:00",
              arrivalTime: "11:10:00",
              daysOfWeek: {
                monday: true,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: true,
                saturday: false,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 85,
            },
            {
              origin: "RMQ",
              destination: "MFM",
              carrierCode: "IT",
              flightNumber: "371",
              departureTime: "07:05:00",
              arrivalTime: "08:45:00",
              daysOfWeek: {
                monday: true,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: true,
                saturday: false,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 100,
            },
            {
              origin: "MFM",
              destination: "RMQ",
              carrierCode: "IT",
              flightNumber: "372",
              departureTime: "20:05:00",
              arrivalTime: "21:30:00",
              daysOfWeek: {
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: true,
                friday: false,
                saturday: false,
                sunday: true,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 85,
            },
          ],
        },
      ],
    },
    {
      countryCode: "TH",
      stationSchedules: [
        {
          iataCode: "HKT",
          schedules: [
            {
              origin: "TPE",
              destination: "HKT",
              carrierCode: "IT",
              flightNumber: "503",
              departureTime: "14:00:00",
              arrivalTime: "17:20:00",
              daysOfWeek: {
                monday: false,
                tuesday: true,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: false,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 260,
            },
            {
              origin: "TPE",
              destination: "HKT",
              carrierCode: "IT",
              flightNumber: "503",
              departureTime: "16:25:00",
              arrivalTime: "19:55:00",
              daysOfWeek: {
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: true,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 270,
            },
            {
              origin: "HKT",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "504",
              departureTime: "18:10:00",
              arrivalTime: "23:25:00",
              daysOfWeek: {
                monday: false,
                tuesday: true,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: false,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 255,
            },
            {
              origin: "HKT",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "504",
              departureTime: "20:45:00",
              arrivalTime: "01:35:00",
              daysOfWeek: {
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: true,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 1,
              durationInMinutes: 1210,
            },
          ],
        },
      ],
    },
    {
      countryCode: "VN",
      stationSchedules: [
        {
          iataCode: "DAD",
          schedules: [
            {
              origin: "KHH",
              destination: "DAD",
              carrierCode: "IT",
              flightNumber: "585",
              departureTime: "16:00:00",
              arrivalTime: "17:35:00",
              daysOfWeek: {
                monday: false,
                tuesday: true,
                wednesday: true,
                thursday: true,
                friday: false,
                saturday: true,
                sunday: true,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 155,
            },
            {
              origin: "KHH",
              destination: "DAD",
              carrierCode: "IT",
              flightNumber: "585",
              departureTime: "17:35:00",
              arrivalTime: "19:10:00",
              daysOfWeek: {
                monday: false,
                tuesday: true,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: true,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 155,
            },
            {
              origin: "DAD",
              destination: "KHH",
              carrierCode: "IT",
              flightNumber: "586",
              departureTime: "18:25:00",
              arrivalTime: "21:40:00",
              daysOfWeek: {
                monday: false,
                tuesday: false,
                wednesday: true,
                thursday: true,
                friday: false,
                saturday: false,
                sunday: true,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 135,
            },
            {
              origin: "DAD",
              destination: "KHH",
              carrierCode: "IT",
              flightNumber: "586",
              departureTime: "19:15:00",
              arrivalTime: "22:30:00",
              daysOfWeek: {
                monday: false,
                tuesday: true,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: true,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 135,
            },
            {
              origin: "TPE",
              destination: "DAD",
              carrierCode: "IT",
              flightNumber: "551",
              departureTime: "16:50:00",
              arrivalTime: "18:25:00",
              daysOfWeek: {
                monday: false,
                tuesday: true,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: true,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 155,
            },
            {
              origin: "TPE",
              destination: "DAD",
              carrierCode: "IT",
              flightNumber: "551",
              departureTime: "17:25:00",
              arrivalTime: "19:10:00",
              daysOfWeek: {
                monday: true,
                tuesday: false,
                wednesday: false,
                thursday: true,
                friday: true,
                saturday: false,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 165,
            },
            {
              origin: "DAD",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "552",
              departureTime: "20:00:00",
              arrivalTime: "23:25:00",
              daysOfWeek: {
                monday: true,
                tuesday: true,
                wednesday: false,
                thursday: true,
                friday: true,
                saturday: true,
                sunday: false,
              },
              operationDateSummary: "2025/10/26-2026/03/28",
              overnight: 0,
              durationInMinutes: 145,
            },
          ],
        },
      ],
    },
  ],
}

export default flightData
